import fetchApi from './fetch-api';

export default async function resetPasswordConfirm(json) {
  await fetchApi({
    method: 'POST',
    path: '/auth/reset/password/confirm',
    json
  });
}
